import { NgModule } from "@angular/core";
import { RegexPasteDirective } from "./regex-paste.directive";
import { RegexDirective } from "./regex.directive";

@NgModule({
    declarations: [RegexDirective, RegexPasteDirective],
    exports: [RegexDirective, RegexPasteDirective]
})
export class RegexDirectiveModule {}